import { render } from "./Gifts.vue?vue&type=template&id=a85ec274"
import script from "./Gifts.vue?vue&type=script&lang=js"
export * from "./Gifts.vue?vue&type=script&lang=js"
script.render = render

export default script